import { StatusEnum } from "./status-enum";

export const statusColors = {
  [StatusEnum.UNPAID]: "default",
  [StatusEnum.PARTIALLY_PAID]: "warning",
  [StatusEnum.FULLY_PAID]: "success",
};
